import React, { useState } from 'react';
import styles from './infoBonifici.module.scss';
import { useDispatch } from 'react-redux';
import { modalActions } from 'Containers/Modals/store';
import ConfirmModal from 'Containers/Common/ConfirmModal';
import { paymentActions } from 'Containers/Payments/store';
import dayjs from 'dayjs';
import HoveredInfoIcon from 'Containers/Common/HoveredInfoIcon';
import clx from 'classnames';
import { useTranslation } from 'react-i18next';
import { Landmark, Pencil } from 'lucide-react';

const InfoBonifici = ({ activeSalon, rows, balanceRows, balance, isMobile }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [isOpenModal, setIsOpenModal] = useState(false);
  const lastRequest_data = rows.length > 0 ? rows.filter((n) => n.disabled === 0 && n.sent === 0)[0] : null;

  function onCurrentWeek(date) {
    const WEEK_LENGTH = 604800000;
    var lastMonday = new Date();
    lastMonday.setDate(lastMonday.getDate() - (lastMonday.getDay() - 1));
    lastMonday.setHours(0, 0, 0, 0);
    const res =
      lastMonday.getTime() <= date.getTime() && date.getTime() < lastMonday.getTime() + WEEK_LENGTH;
    return res;
  }

  const totCommissions = balance * 0.029 + balanceRows * 0.15;
  const saldo = balance > 0 ? balance - totCommissions * 1.22 : 0;
  const canRequired = onCurrentWeek(new Date(rows.filter((n) => n.disabled === 0)[0]?.data));
  const canRequestNow = !lastRequest_data && !canRequired && activeSalon.titolare_iban && activeSalon.iban;

  const openIbanModal = () => {
    dispatch(
      modalActions.OPEN_MODAL.SUCCESS({
        type: 'editSalonIbanModal',
        props: { activeSalon: activeSalon },
      }),
    );
  };

  return (
    <div className={clx(styles.container, { [styles.container_mobile]: isMobile })}>
      <ConfirmModal
        isModalOpen={isOpenModal}
        setIsModalOpen={setIsOpenModal}
        title={t('payments.infoBonifici.confirmRequestTitle')}
        content={
          <div style={{ padding: '10px 20px 5px' }}>
            {t('payments.infoBonifici.confirmRequestContent')}
          </div>
        }
        action={() => {
          const req = {
            idSalone: activeSalon.idsalone,
            nomeSalone: activeSalon.nome_salone,
            data_richiesta: dayjs().format('YYYY-MM-DD'),
            titolare_iban: activeSalon.titolare_iban,
            iban: activeSalon.iban,
            saldo,
          };
          dispatch(paymentActions.SEND_REQUEST.REQUEST(req));
          setIsOpenModal(false);
        }}
      />
        <div className={styles.settings}>
          <div className={styles.title_row}>
            <span className={styles.title_icon} aria-hidden="true">
              <Pencil size={16} strokeWidth={2.2} />
            </span>
            <h2 className={styles.title}>{t('payments.infoBonifici.bankTransferInfo')}</h2>
          </div>
          <div className={styles.section_item}>
            <div className={styles.item}>
              <span className={styles.label}>{t('payments.infoBonifici.accountHolder')}</span>
              <span className={styles.text_gray}>
                {activeSalon.titolare_iban ?? t('payments.infoBonifici.accountHolderPlaceholder')}
              </span>
            </div>
            <button
              type="button"
              className={styles.icon_action}
              onClick={openIbanModal}
              aria-label={t('payments.infoBonifici.accountHolder')}
            >
              <Pencil size={14} strokeWidth={2.2} />
            </button>
          </div>
          <div className={styles.section_item}>
            <div className={styles.item}>
              <span className={styles.label}>{t('payments.infoBonifici.iban')}</span>
              <span className={styles.text_gray}>
                {activeSalon.iban ?? t('payments.infoBonifici.ibanPlaceholder')}
              </span>
            </div>
            <button
              type="button"
              className={styles.icon_action}
              onClick={openIbanModal}
              aria-label={t('payments.infoBonifici.iban')}
            >
              <Pencil size={14} strokeWidth={2.2} />
            </button>
          </div>
        </div>
        <div className={styles.card}>
          <div className={styles.title_row}>
            <span className={styles.title_icon} aria-hidden="true">
              <Landmark size={16} strokeWidth={2.2} />
            </span>
            <h2 className={styles.title}>{t('payments.infoBonifici.requestBankTransfer')}</h2>
          </div>
          <div className={styles.balance_row}>
            <span className={styles.text_gray}>
              {t('payments.infoBonifici.availableBalance')}
              <HoveredInfoIcon
                sidePosition={'right'}
                description={t('payments.infoBonifici.availableBalanceDescription')}
              />
            </span>
            <span className={clx(styles.amount, { [styles.amount_negative]: saldo < 0 })}>
              €{saldo.toFixed(2)}
            </span>
          </div>
          {canRequestNow ? (
            <button
              type="button"
              className={clx(styles.confirm_button, { [styles.confirm_button_disable]: saldo <= 0 })}
              onClick={saldo > 4 ? () => setIsOpenModal(true) : undefined}
              style={{ cursor: saldo > 4 ? 'pointer' : 'not-allowed' }}
            >
              <Landmark size={16} strokeWidth={2.2} />
              {t('payments.infoBonifici.sendRequest')}
            </button>
          ) : (
            <div className={styles.hint}>
              {activeSalon.titolare_iban && activeSalon.iban ? (
                <>
                  {t('payments.infoBonifici.nextRequestInfo')}
                  <HoveredInfoIcon description={t('payments.infoBonifici.weeklyRequestInfo')} />
                </>
              ) : (
                <>
                  {t('payments.infoBonifici.missingInfoMessage')}
                  <HoveredInfoIcon description={t('payments.infoBonifici.missingInfoDescription')} />
                </>
              )}
            </div>
          )}
        </div>
    </div>
  );
};

export default InfoBonifici;
